module.exports = __webpack_public_path__ + "images/4-h66e739064226675808c14cdc8b0e5c38.svg";